import { AppState } from '../reducers/rootReducer';
import { IFilterState } from '../reducers/filterSortReducer';

export const selectPageFilters = <T extends keyof IFilterState>(state: AppState, pageKey: T): IFilterState[T] =>
  state.filters.filter[pageKey];
